<template>
  <div class="container layout flex-wrap p-t-6">
    <div class="layout-item is-12 text-center p-y-6">
      <h2 class="h2 text-bold p-b-2">Pro Referral Requirements</h2>
      <p class="subheading text-lg p-x-6 d-none:mo">
        To increase trust and ensure compliance, Pros are required to provide a few
        basic pieces of information.
      </p>
      <p class="subheading text-lg d-none:t">
        To ensure trust and compliance, Pros are required to provide some basic documentation.
      </p>
    </div>
    <div class="layout-item is-12 layout flex-wrap p-x-2 p-b-4">
      <div class="layout-item is-12 is-5:d">
        <div class="REQ-HEADER" id="req-id">
          <h6 class="h6 text-bold m-b-2 c-gray80">ID verification</h6><span>
            <p class="text-md d-none:mo">
              Your driver's license or passport, which includes your profile picture,
              helps verify your identity and personalize your business.
            </p>
            <p class="text-md d-none:t">Your driver's license or passport, which includes your
            profile picture, helps verify your identity and personalize your business.</p></span>
        </div>
      </div>

      <div class="layout-item is-12 is-2:d d-none:mo">&nbsp;</div>

      <div class="layout-item is-12 is-5:d">
        <div class="REQ-HEADER" id="req-gl">
          <h6 class="h6 text-bold  m-b-2 c-gray80">General Liability insurance</h6>
          <p class="text-md d-none:mo">Pro Referral providers are required to carry appropriate
          General Liability insurance.
          You will need to provide proof of coverage. </p>
          <p class="text-md d-none:t">Pro Referral providers need to provide proof of
          General Liability insurance coverage.</p>
          <a
              class="link text-lg p-t-1 c-depot"
              @click.prevent="openModal">
            See an example
          </a>
          <vk-modal
              v-if="isOpen"
              :is-open="isOpen"
              @close="closeModal">
            <vk-modal-body>
              <vk-modal-header   class="text-center c-gray60 p-l-6 bd-b-gray40">
                <span>Sample of General Liability Certificate</span>
              </vk-modal-header>
              <vk-modal-content class="d-flex fd-column p-0">
                <div class="bg-white">
                  <div class="d-flex p-4:d">
                    <img
                        class="as-center w-100"
                        :src="image"
                    />
                  </div>
                </div>
              </vk-modal-content>
              <vk-modal-footer class="d-flex jc-end w-100">
                <div>
                  <button @click="closeModal" class="m-t-2 p-x-4 m-x-auto btn">
                    Close
                  </button>
                </div>
              </vk-modal-footer>
            </vk-modal-body>
          </vk-modal>
        </div>
      </div>

      <div class="layout-item is-12 is-5:d">
        <div class="REQ-HEADER" id="req-background-check">
          <h6 class="h6 text-bold  m-b-2 c-gray80">Background check</h6><span>
            <p class="text-md d-none:mo">To provide customers peace of mind, Pros are required
            to pass a background check.
            We provide this service for a low $41.99 fee.</p>
            <p class="text-md d-none:t">Pros are required to pass a background check,
            a service we provide for $41.99.</p></span>
        </div>
      </div>

      <div class="layout-item is-12 is-2:d d-none:mo">&nbsp;</div>

      <div class="layout-item is-12 is-5:d">
        <div class="REQ-HEADER" id="req-license">
          <h6 class="h6 text-bold m-b-2 c-gray80 d-none:mo">Contractor license</h6>
          <h6 class="h6 text-bold m-b-2 c-gray80 d-none:t">Proper licensing</h6>
          <p class="text-md d-none:mo">Depending on your occupations and where you do business in,
          you may be required to provide your license information.</p>
          <p class="text-md d-none:t">You may be required to provide trade license information
          for the state you do business in.</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'pro-requirements',

  data () {
    return {
      isOpen: false,
      image: 'https://thdserviceprovider.my.site.com/pro/resource/1726619783000/BecomeaPro_Landing_Assets/images/gl_1024.png',
      title: 'Sample of General Liability Certificate',
      cta: 'Close',


    };
  },
  methods: {
    openModal () {
      this.isOpen = true;
    },
    closeModal () {
      this.isOpen = false;
    },
  },

};
</script>
<style lang="scss" scoped>

.REQ-HEADER {
  box-sizing: border-box;
  color: rgb(67, 72, 76);
  display: block;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  font-size: 16px;
  height: 119px;
  line-height: 16px;
  margin: 32px 0;
  padding-left: 82px;
  position: relative;
  text-size-adjust: 100%;
  unicode-bidi: isolate;
  width: 348.844px;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.REQ-HEADER:before {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  box-sizing: content-box;
  color: rgb(67, 72, 76);
  content: "";
  display: block;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  font-size: 16px;
  height: 64px;
  left: 0;
  line-height: 16px;
  position: absolute;
  text-size-adjust: 100%;
  width: 64px;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

div#req-id.REQ-HEADER:before {
  background-image: url('https://thdserviceprovider.my.site.com/pro/resource/1726619783000/BecomeaPro_Landing_Assets/images/requirements-ID-verification.svg');
}

div#req-gl.REQ-HEADER:before {
  background-image: url('https://thdserviceprovider.my.site.com/pro/resource/1726619783000/BecomeaPro_Landing_Assets/images/requirements-general-liability.svg');
}

div#req-background-check.REQ-HEADER:before {
  background-image: url('https://thdserviceprovider.my.site.com/pro/resource/1726619783000/BecomeaPro_Landing_Assets/images/requirements-background-check.svg');
}

div#req-license.REQ-HEADER:before {
  background-image: url('https://thdserviceprovider.my.site.com/pro/resource/1726619783000/BecomeaPro_Landing_Assets/images/requirements-license.svg');
}
</style>
